// Polyfills
import 'whatwg-fetch'

// Request the backend
const Request = async (uri, method, body, relative = true, file = false) => {
    let requestPath = '';
    const options = {
        method: method,
        headers: {
            'X-Requested-With': 'XMLHttpRequest'
        }
    }
    if (relative) {
        options.credentials = 'include';
    }
    if (method.toUpperCase() === 'GET' || method.toUpperCase() === 'DELETE') {
        requestPath = uri + buildParams(body);
    } else {
        requestPath = uri;

        if (file) {
            const formData = new FormData();
            Object.entries(body).map((el) => {
                const key = el[0];
                const data = el[1];
                if (data instanceof Blob) {
                    formData.append(key, data)
                } else if (typeof data === 'object') {
                    formData.append(key, JSON.stringify(data))
                } else {
                    formData.append(key, data)
                }
            })
            options.body = formData;
        } else {
            options.body = JSON.stringify(body);
            options.headers['Content-Type'] = 'application/json; charset=UTF-8'
        }
    }
    const response = await fetch(requestPath, options);
    if (response.status !== 200) {
        try {
            const contentType = response.headers.get('Content-Type') || '';
            if (contentType.includes('application/json')) {
                return response.json();
            }
        } catch (e) {
            console.error(e);
        }
        return Promise.reject(`Request to ${requestPath} failed`);
    }
    const jsonResponse = await response.json()
    if (jsonResponse.redirect && jsonResponse.path) {
        window.location.href = jsonResponse.path;
        return {success: false, message: $t('Utgått sesjon') };
    }
    return jsonResponse;
}

const Get = (uri, params, relative = true) => Request(uri, 'GET', params, relative);

const Post = (uri, body, relative = true, file = false) => Request(uri, 'POST', body, relative, file);

const Put = (uri, body, relative = true, file = false) => Request(uri, 'PUT', body, relative, file);

const Delete = (uri, body, relative = true) => Request(uri, 'DELETE', body, relative);

// Build params for GET-requests
const buildParams = (params) => {
    let str = '';
    for (const param in params) {
        if (!params.hasOwnProperty(param)) continue;
        str += (str.length ? '&' : '?') + param + '=' + params[param]
    }
    return str
};


export const buildUrl = (path, params) => {
    return path + buildParams(params)
};

export default {
    Request,
    Get,
    Post,
    Put,
    Delete,
    buildUrl
}
